<template>
    <div>
        <b-list-group>
            <b-list-group-item v-if="!richieste.length" variant="secondary"><span>Non ci sono richieste al momento.</span></b-list-group-item>
            <b-list-group-item v-for="utente in richieste" :key="utente.uid" class="list-item">
                <b-row>
                    <b-col class="list-item-left"><span> {{utente.first_name}} {{utente.last_name}}</span></b-col>
                    <b-col class="list-item-center"><span> {{utente.email}}</span></b-col>
                    <b-col class="list-item-right">
                        <img src="@/assets/tick.svg" class="list-img-tick" @click="openEditModal(utente)"/>
                        <img src="@/assets/x.svg" class="list-img-x" @click="openDeleteModal(utente)"/>
                    </b-col>
                </b-row>
            </b-list-group-item>
        </b-list-group>

        <b-modal id="editModal" size="lg" :hide-header="true" button-size="sm" ok-variant="success" cancel-title="Annulla" @ok="registerUser">
            <EditUserGroups ref="editModal" @closeModal="$bvModal.hide('editModal')" :user="this.userToEdit" />
        </b-modal>
        <b-modal id="confirmDelete" size="lg" :title="userToDelete.first_name + ' ' + userToDelete.last_name" button-size="sm" ok-variant="danger" cancel-title="Annulla" @ok="deleteRequest">
            <span> Sei sicuro di voler rifiutare questa richiesta? Se confermi, i dati dell'utente verranno cancellati permanentemente e la persona dovrà rifare una nuova richiesta.</span>
        </b-modal>
    </div>
</template>

<script>
import EditUserGroups from '@/components/Edit-User-Groups.vue';
import { mixins } from "@/mixins";

export default {
    name: "RichiesteAccesso",
    data(){
        return {
            richieste: Array,
            userToEdit: Object,
            userToDelete: Object,
        }
    },
    components: {
        EditUserGroups
    },
    mixins: [mixins],
    mounted(){
        this.getRequests()
    },
    methods: {
        openEditModal: function(user){
            this.userToEdit = user;
            this.$bvModal.show('editModal');
        },
        openDeleteModal: function(user){
            this.userToDelete = user;
            this.$bvModal.show('confirmDelete');
        },
        registerUser: function(bvModalEvt){
            bvModalEvt.preventDefault()
            if(this.$refs.editModal.selectedUserRoles.length==0){
                this.$refs.editModal.showErrorAlert = true;
            }
            else{
                this.$axios
                .post(this.$apibase + '/api/users/set_user_group/', 
                {
                    user: this.userToEdit.uid,
                    groups: this.$refs.editModal.selectedUserRoles,
                    isNewUser: true
                },
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                })
                .then(() => {
                    this.$bvModal.hide('editModal');
                    this.getRequests()
                    this.$store.dispatch('setAlert', {message: "Utente modificato con successo.", type: 'success'});
                })
                .catch((e)=> {
                    if (e.response.status == 403)
                        this.logout();
                    else
                        alert(e.response);
                })
            }
        },
        getRequests: function(){
            this.$axios
            .get(this.$apibase + '/api/users/get_unverified_users/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(response => {
                    this.richieste = response.data;
                })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        },
        deleteRequest: function() {
            this.$axios
            .delete(this.$apibase + '/api/users/' + this.userToDelete.uid, {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(() => {
                    this.$bvModal.hide('confirmDelete');
                    this.getRequests()
                    this.$store.dispatch('setAlert', {message: "Richiesta eliminata con successo.", type: 'success'});
                })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        }
        
    }
}
</script>

<style scoped>
    .list-item-left{
        text-align: left;
    }
    .list-item-center{
        text-align: center;
    }
    .list-item-right{
        text-align: right;
    }
    .list-img-x{
        width: 15px;
        margin-left: 20px;
        cursor: pointer;
    }
    .list-img-tick{
        width: 20px;
        cursor: pointer;
    }
    .list-item{
        padding-left: 40px;
        padding-right: 40px;
    }
</style>